module.exports = __webpack_public_path__ + "fonts/motiva-sans-black-italic.521ff6c.otf";